import React, { memo, useCallback, useMemo } from 'react'

import { Icon, MoreChorizontal } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func, string } from 'prop-types'

import Dropdown from 'Pods/ThreeDStudio/Shared/Dropdown/Dropdown'

import Menu from './Components/Menu/Menu'

// Same layer as the detached History window (_detached_window.scss): the menu is
// portalled when opened, after the window, so it paints over it while staying under
// the site navbar (453).
const PORTAL_Z_INDEX = 452
const triggerIconSize = { height: '36px', width: '36px' }
const triggerIcon = <Icon notSpaced svgComponent={MoreChorizontal} color="dark" size={triggerIconSize} />

function VariationMenu({
  className,
  createdAt = undefined,
  canSetAsMain = true,
  isDisabled = false,
  sourceItemUrl = undefined,
  shouldClose,
  setShouldClose,
  onOpenChange,
  onSetAsMain,
  onDelete,
}) {
  const handleViewSourceItem = useCallback(() => setShouldClose(true), [setShouldClose])

  const content = useMemo(() => (
    <Menu
      createdAt={createdAt}
      sourceItemUrl={sourceItemUrl}
      canSetAsMain={canSetAsMain}
      onSetAsMain={onSetAsMain}
      onDelete={onDelete}
      onViewSourceItem={handleViewSourceItem}
      isDisabled={isDisabled}
    />
  ), [createdAt, sourceItemUrl, canSetAsMain, onSetAsMain, onDelete, handleViewSourceItem, isDisabled])

  return (
    <Dropdown
      icon={triggerIcon}
      content={content}
      placement="bottom-start"
      className={className}
      contentClassName="variation-menu__content"
      triggerCloseDropdown={shouldClose}
      setTriggerCloseDropdown={setShouldClose}
      onOpenChange={onOpenChange}
      portalZIndex={PORTAL_Z_INDEX}
    />
  )
}

VariationMenu.propTypes = {
  className: string.isRequired,
  createdAt: string,
  canSetAsMain: bool,
  isDisabled: bool,
  sourceItemUrl: string,
  shouldClose: bool.isRequired,
  setShouldClose: func.isRequired,
  onOpenChange: func.isRequired,
  onSetAsMain: func.isRequired,
  onDelete: func.isRequired,
}

export default memo(VariationMenu)
